import * as ko from "knockout";
import * as Constants from "../common/constants";
import * as Global from "../common/global";
import * as UI from "../common/ui";
import * as templateAccessRoleData from "../data/templateAccessRoleData";
import { ITemplateAccessRole } from "../data/templateAccessRoleData";
import { IApplication } from "../interfaces/application";
import { IController } from "../interfaces/controller";

interface IViewModel {
    Roles: KnockoutObservableArray<ITemplateAccessRole>;
    deleteRole: (role: ITemplateAccessRole) => void;
    editRole: (role: ITemplateAccessRole) => void;
    TemplateSecurityEnabled: KnockoutObservable<boolean>;
}

export class TemplateAccessRolesController implements IController {
    private container: JQuery;
    private viewModel: IViewModel;

    constructor() {
        const me = this;
        const app: IApplication = Global.app();

        this.viewModel = {
            Roles: ko.observableArray(),
            TemplateSecurityEnabled: ko.observable(false),
            deleteRole: (role: ITemplateAccessRole) => {
                UI.showConfirmDialog("Are you sure you want to delete this role?", () => {

                    const waitContainer: JQuery<HTMLElement> = UI.showWaitIndicator(me.container);

                    role.IsActive = false;
                    templateAccessRoleData.Delete(role.ID)
                        .then((response) => {

                            if (response.Success) {
                                UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                            } else {
                                UI.showErrorMessage(response.ErrorMessages);
                            }

                            this.load([]);
                        })
                        .always(() => {
                            UI.hideWaitIndicator(me.container, waitContainer);
                        });
                });
            },
            editRole: (role: ITemplateAccessRole) => {
                app.router().navigate(`/TemplateAccessRole/${role.ID}`, true);
            },
        };

        if (app.userSession) {
            const setting = UI.GetCustomerSetting(app.userSession.CustomerSettings, Constants.SETTING_KEY_TEMPLATE_ACCESS_SECURITY, "false");
            this.viewModel.TemplateSecurityEnabled(setting === "true");
        }
    }

    public render(container: JQuery<HTMLElement>): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.container = container;

        ko.applyBindings(this.viewModel, this.container[0]);

        deferred.resolve();
        return deferred.promise();
    }

    public refresh() {
        this.load([]);
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const me = this;

        const waitContainer: JQuery<HTMLElement> = UI.showWaitIndicator(me.container);

        templateAccessRoleData.GetAll()
            .then((response) => {
                if (response.Success) {
                    me.viewModel.Roles(response.Payload);
                } else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
                deferred.resolve();
            })
            .always(() => {
                UI.hideWaitIndicator(me.container, waitContainer);
            });

        return deferred.promise();
    }

    public add(): void {
        if (this.viewModel.TemplateSecurityEnabled()) {
            const app: IApplication = Global.app();
            app.router().navigate(`/TemplateAccessRole`, true);
        }
    }

    public haveFieldsChanged(): boolean {
        return false;
    }

    public appRouterID(params: any[]): string {
        return "TemplateAccessRoles";
    }

    public title(): string {
        return "Template Access Roles";
    }

    public subTitle(): string {
        return "";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/templateAccessRoles.ts